import type { OtterfolioOverview, OtterfolioPosition } from "../../lib/otterfolio";
import { CompactPositionTile } from "./CompactPositionTile";
import { KpiStrip } from "./KpiStrip";
import { OTTERFOLIO_THEME } from "./theme";
import { ValueChartCard } from "./ValueChartCard";

function fmtEur(cents: number): string {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);
}

function sortByValueDesc(list: OtterfolioPosition[]): OtterfolioPosition[] {
  return [...list].sort((a, b) => b.valueCents - a.valueCents);
}

interface Props {
  overview: OtterfolioOverview;
}

export function VideoMode({ overview }: Props) {
  const fels = sortByValueDesc(overview.positions.filter((p) => p.investmentCategory === "FELS"));
  const rakete = sortByValueDesc(
    overview.positions.filter((p) => p.investmentCategory === "RAKETE"),
  );

  return (
    <div
      style={{
        aspectRatio: "16 / 9",
        width: "100%",
        maxHeight: "calc(100vh - 100px)",
        minHeight: 600,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <div style={{ flex: "0 0 auto" }}>
        <KpiStrip overview={overview} />
      </div>
      <div style={{ flex: "1 1 35%", minHeight: 180, marginBottom: 28 }}>
        <ValueChartCard
          valueHistory={overview.valueHistory}
          benchmarkLabel={overview.benchmarkLabel}
        />
      </div>
      <div style={{ flex: "1 1 50%", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <section style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}>
          <header
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: OTTERFOLIO_THEME.fels,
              textTransform: "uppercase",
              letterSpacing: 1,
              paddingBottom: 4,
              borderBottom: `1px solid ${OTTERFOLIO_THEME.cardBorder}`,
            }}
          >
            🪨 Fels · {fels.length} Pos · {fmtEur(overview.fels.valueCents)}
          </header>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 6, flex: 1 }}>
            {fels.map((p) => (
              <CompactPositionTile key={p.id} position={p} />
            ))}
          </div>
        </section>
        <section style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}>
          <header
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: OTTERFOLIO_THEME.rakete,
              textTransform: "uppercase",
              letterSpacing: 1,
              paddingBottom: 4,
              borderBottom: `1px solid ${OTTERFOLIO_THEME.cardBorder}`,
            }}
          >
            🚀 Rakete · {rakete.length} Pos · {fmtEur(overview.rakete.valueCents)}
          </header>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 6, flex: 1 }}>
            {rakete.map((p) => (
              <CompactPositionTile key={p.id} position={p} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
